import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Shipment} from '../domain/shipment';
import {filter} from 'rxjs/operators';
import {EventListEntry} from '../admin/shipment/shipment-details/event-list-entry';
import {EventNamePipe} from '../component/event-name-pipe';
import {PopupService} from '../component/popup.service';
import {LoginComponent} from '../login/login/login.component';
import {Session} from '../domain/session';

@Component({
    selector: 'app-track',
    templateUrl: './track.component.html',
    styleUrls: ['./track.component.css'],
    standalone: false
})
export class TrackComponent implements OnInit {
  shipment: Shipment;

  searchQuery: string;

  error: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventNamePipe: EventNamePipe,
    private popupService: PopupService,
    public session: Session) {
  }

  ngOnInit() {
    this.initValue();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.initValue();
      });
  }

  private initValue() {
    let response = this.route.snapshot.data['shipment'];

    if (response !== undefined) {
      if (response.error === undefined) {
        this.shipment = response;
        this.error = null;
      } else {
        this.shipment = undefined;
        this.error = response;
      }
    }

    this.searchQuery = this.route.snapshot.paramMap.get('query');
  }

  login() {
    this.popupService.openFromComponent(LoginComponent, {},{dynamicHeight: true})
  }

  search() {
    this.router.navigate(['track', this.searchQuery]);
  }

  getEvents(): EventListEntry[] {
    let result: EventListEntry[] = [];

    this.shipment.Parcels.forEach(p => {
      p.Events.forEach(e => {
        result.push({
          createdAt: e.CreatedAt,
          attachmentIds: [],
          name: this.eventNamePipe.transform(e.Type),
          description: null,
          parcelDescription: null,
          number: 'Kolli ' + p.Number,
          signature: null,
          username: ''
        });
      });

      p.Deviations.forEach(d => {
        result.push({
          createdAt: d.CreatedAt,
          attachmentIds: [],
          name: d.DefinitionName.NO,
          description: '',
          parcelDescription: null,
          number: 'Kolli ' + p.Number,
          signature: null,
          username: ''
        });
      });
    });

    this.shipment.Deviations.forEach(d => {
      result.push({
        createdAt: d.CreatedAt,
        attachmentIds: [],
        name: d.DefinitionName.NO,
        description: '',
        parcelDescription: null,
        number: 'Sending ' + this.shipment.Number,
        signature: null,
        username: ''
      });
    });

    result = result.sort((a, b) => {
      return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    });

    return result;
  }

}
